<div class="container mx-auto px-2 sm:px-3">
  <!-- Product Cards -->
  <div class="grid grid-cols-2 md:grid-cols-3 mx-16 3xl:mx-0 lg:grid-cols-4 gap-2 sm:gap-2">
    <!-- Skeleton Loader -->
    @if (isLoading) { @for (item of skeletonArray; track item) {
    <div
      class="animate-pulse bg-gray-200 rounded-lg shadow-md overflow-hidden h-[200px] sm:h-[240px]"
    >
      <div class="bg-gray-300 h-24 sm:h-32 w-full"></div>
      <div class="p-2">
        <div class="h-3 bg-gray-300 rounded w-3/4 mb-1"></div>
        <div class="h-2 bg-gray-200 rounded w-1/2 mb-1"></div>
        <div class="h-2 bg-gray-200 rounded w-full mb-1"></div>
        <div class="h-2 bg-gray-200 rounded w-full mb-1"></div>
        <div class="h-5 bg-gray-300 rounded w-full mt-1"></div>
      </div>
    </div>
    } }

    <!-- Product Card -->
    @for (product of products; track product.pd_id) {
    <div
      #productCard
      [ngClass]="{
        'bg-white': isOpen,
        'bg-gray-300': !isOpen,
        'cursor-pointer': isOpen,
        'cursor-not-allowed': !isOpen,
        'opacity-60': !isOpen
      }"
      class="rounded-lg border border-gray-200 overflow-hidden transition-transform duration-200 hover:shadow-sm"
      (click)="isOpen ? openProductModal(product) : null"
    >
      <!-- Product Image -->
      <div class="relative">
        <img
          [src]="
            product.pd_image ? product.pd_image : 'assets/imagen_default.png'
          "
          [alt]="product.pd_name"
          [ngClass]="{
            grayscale: !isOpen,
            'opacity-50': !isOpen
          }"
          class="w-full h-20 sm:h-24 object-cover"
          (error)="onImageError($event)"
        />
      </div>
      <!-- Product Details -->
      <div class="p-1.5 sm:p-2 flex flex-col h-[100px] sm:h-[120px]">
        <div class="flex-grow overflow-hidden">
          <div class="flex justify-between items-start mb-0.5">
            <h3
              [ngClass]="{
                'text-gray-900': isOpen,
                'text-gray-500': !isOpen
              }"
              class="text-[11px] sm:text-sm font-semibold truncate max-w-[70%]"
            >
              {{ product.pd_name }}
            </h3>
            <span
              [ngClass]="{
                'text-yellow-500': isOpen,
                'text-gray-400': !isOpen
              }"
              class="font-bold ml-1 text-[11px] sm:text-xs"
              >${{ (+product.pd_unit_price || 0).toFixed(2) }}</span
            >
          </div>
          <p
            [ngClass]="{
              'text-gray-500': isOpen,
              'text-gray-400': !isOpen
            }"
            class="text-[10px] mb-0.5 sm:block truncate"
          >
            {{ product.pd_name }}
          </p>
          <p
            [ngClass]="{
              'text-gray-700': isOpen,
              'text-gray-400': !isOpen
            }"
            class="text-[10px] mb-1 sm:block line-clamp-2 max-h-[2rem] overflow-hidden"
          >
            {{ product.pd_description }}
          </p>
          <div class="flex justify-between items-center hidden sm:flex">
            <!-- Stock indicator -->
          </div>
        </div>
        <!-- Add to Cart Button -->
        <button #addBtn
          [ngClass]="{
            'bg-yellow-400 text-gray-900 hover:bg-yellow-500': isOpen,
            'bg-gray-400 text-gray-600 cursor-not-allowed': !isOpen
          }"
          [disabled]="!isOpen"
          class="cursor-pointer w-full py-0.5 sm:py-1 px-1.5 sm:px-2 rounded-md transition-colors duration-200 flex items-center justify-center text-[12px] mt-auto"
          (click)="onAddToCart(addBtn, cartIcon, product); $event.stopPropagation()"
        >
          <i #cartIcon class="fa-solid fa-cart-shopping text-[12px] mr-1"></i>
          Agregar al carrito
        </button>
      </div>
    </div>
    }
  </div>
  <!-- Loading Trigger Element -->
  @if (products.length > 0 && !isLoading) {
  <div #loadingTrigger class="col-span-full flex justify-center py-4 my-2">
    <div class="animate-pulse flex space-x-2">
      <div class="w-2 h-2 bg-gray-300 rounded-full"></div>
      <div class="w-2 h-2 bg-gray-300 rounded-full"></div>
      <div class="w-2 h-2 bg-gray-300 rounded-full"></div>
    </div>
  </div>
  }
</div>

<!-- El modal ahora se muestra a nivel de aplicación -->
